import { Grid } from "@material-ui/core";
import { AutocompleteComponent } from "components/Autocomplete/AutocompleteComponent";
import React from "react";
import { ModalV2 } from "components/Modal/ModalV2";
import { useAddUnitEmployeeForm } from "./hooks";

export const AddUnitEmployeeForm = ({
  data = {},
  setOpen = () => {},
  open = false,
  title = "Asignar empleado",
}) => {
  const {
    activeEmployees,
    values,
    handleSubmit,
    handleDriver,
    handleHelper,
    handleSecondHelper,
    isLoadingComp,
    hasChanges,
  } = useAddUnitEmployeeForm(data, setOpen);
  const { idEmployee, idHelper, idSecondHelper } = values;

  return (
    <ModalV2
      title={title}
      open={open}
      onClose={setOpen}
      onSubmit={handleSubmit}
      justConfirm
      disabledBtn={!hasChanges}
    >
      <Grid item xs={12}>
        <AutocompleteComponent
          label="Chofer"
          name="idEmployee"
          options={activeEmployees}
          value={idEmployee}
          customAction={handleDriver}
          loading={isLoadingComp?.updateUnitEmployee}
          sort
        />
      </Grid>
      <Grid item xs={12}>
        <AutocompleteComponent
          label="Chofer auxiliar"
          name="idHelper"
          options={activeEmployees}
          value={idHelper}
          customAction={handleHelper}
          loading={isLoadingComp?.updateUnitEmployee}
          sort
        />
      </Grid>
      <Grid item xs={12}>
        <AutocompleteComponent
          label="Segundo chofer auxiliar"
          name="idSecondHelper"
          options={activeEmployees}
          value={idSecondHelper}
          customAction={handleSecondHelper}
          loading={isLoadingComp?.updateUnitEmployee}
          sort
        />
      </Grid>
    </ModalV2>
  );
};
